import axios from 'axios';

const RELOAD_GUARD_KEY = '__xm_build_reload_guard__';

/**
 * 对比当前运行包与服务器 buildInfo，若版本不一致则自动刷新一次。
 * 解决登录后仍加载旧缓存资源、需手动刷新的问题。
 */
export async function checkAppVersionAndReload(): Promise<boolean> {
  if (process.env.NODE_ENV !== 'production') {
    return true;
  }
  try {
    const url = new URL('/buildInfo.json', location.origin).toString();
    const { data: { buildTime } } = await axios.get<{ buildTime: string }>(url, {
      params: { _t: Date.now() },
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    });
    const bundleBuildTime = __APP_INFO__?.lastBuildTime;
    if (!buildTime || !bundleBuildTime) {
      return true;
    }
    if (buildTime === bundleBuildTime) {
      sessionStorage.removeItem(RELOAD_GUARD_KEY);
      return true;
    }
    const guard = sessionStorage.getItem(RELOAD_GUARD_KEY);
    if (guard === buildTime) {
      return true;
    }
    sessionStorage.setItem(RELOAD_GUARD_KEY, buildTime);
    location.reload();
    return false;
  } catch (e) {
    console.log('[checkAppVersion]', e);
    return true;
  }
}
